import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)


// 公共路由
export const constantRoutes = [
  {
    path: '/',
    name: 'PageDetail',
    component: () => import('@/views/detail/index'),
  },
  {
    path: '/pressure-gauge',
    name: 'PressureGauge',
    component: () => import('@/views/pressure-gauge/index'),
  },
  {
    path: '/valve-control',
    name: 'ValveControl',
    component: () => import('@/views/valve/index'),
  },
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

